import Header from '../../../../Components/Header'
import PurchaseReciept from './PurchaseRecipt'
import { Helmet } from "react-helmet";

function EditPurchaseRecipt() {
    return (
        <div className='d-flex flex-column' style={{ height: '99.8vh' }}>
            <Helmet>
                <title>GRN - Edit</title>
            </Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column " style={{flexGrow:'1'}}>
                <PurchaseReciept />
            </div>
        </div>
    )
}

export default EditPurchaseRecipt
